import React from 'react';
import { Redirect } from 'react-router';
import classNames from 'classnames';
import { Spinner } from '@grpn/mx-components';

import { BusinessType, ListOfPds } from '../../types';
import {
  Input,
  RadioButton,
  Select,
  SelectOption,
  TagAutocomplete,
  TagAutocompleteItem,
} from '@grpn/mx-components';

import styles from './index.module.styl';
import { STATES, COUNTRIES_PICKER } from '../../constants';
import { BusinessInfo as BusinessInfoType, Countries } from '../../types';

import { I18n, getTranslator } from '../../helpers/i18n';
import { trackBloodhoundEvent } from '../../helpers/tracking';
import { getTermsOfUseUrl, getDataPrivacyUrl } from '../../helpers/url';
import { testId } from '../../helpers/test-id';
import Multiselect from './../multiselect-dropdown/multiselect';
import IconCategoryHBW from './Icons/icon-beauty';
import IconCategoryAE from './Icons/icon-activities';
import IconCategoryGR from './Icons/icon-occasion';
import IconCategoryFD from './Icons/icon-restaurant';
import IconCategoryHA from './Icons/icon-home';

const consentMessageParams = {
  termsOfUseLinkStart: `<a href=${getTermsOfUseUrl(
    I18n.country,
  )} target='_blank' rel='noopener noreferrer'>`,
  termsOfUseLinkEnd: '</a>',
  privacyStatementLinkStart: `<a href=${getDataPrivacyUrl(
    I18n.country,
  )} target='_blank' rel='noopener noreferrer'>`,
  privacyStatementLinkEnd: '</a>',
};

const businessTypes = [
  {
    key: 'food',
    value: 'Food & Drink',
  },
  {
    key: 'beauty',
    value: 'Beauty / Wellness / Healthcare',
  },
  {
    key: 'activities',
    value: 'Leisure Offers / Activities',
  },
  {
    key: 'services',
    value: 'Services',
  },
  {
    key: 'tickets',
    value: 'Tickets',
  },
  {
    key: 'goods',
    value: 'Goods',
  },
  {
    key: 'travel',
    value: 'Travel',
  },
];
const categories = [
  'categoryHBW',
  'categoryAE',
  'categoryGR',
  'categoryHA',
  'categoryFD',
  'categoryOS',
];
const iconCategories = [
  'IconCategoryHBW',
  'IconCategoryAE',
  'IconCategoryGR',
  'IconCategoryHA',
  'IconCategoryFD',
  'IconCategoryOS',
];

const translate = getTranslator('_businessInfo');

type Props = {
  update: (data: Object) => void;
  fetchBusinessTypes?: () => void;
  businessTypes: ListOfPds[];
  onSubmit: (data: BusinessInfoType, country: Countries) => void;
};

type State = {
  suggestions: BusinessType[];
  usBusinessTypeValie: string;
  isAutocompleteOpen: boolean;
  listOfPds: ListOfPds[];
  listOfSelectedPds: BusinessType[];
  selectedPdsItems: string;
  listOfPdsDropdown: ListOfPds[];
  defaultCategory: string;
  isSelected: string;
};

type BusinessInfoProps = Props & BusinessInfoType;

interface SelectorProps {
  name: string;
  value: string;
}

const getDefaultState = (country: Countries): String => {
  const states = STATES[country];
  if (Boolean(states) && states!.length > 0) {
    return states![0].name;
  }
  return '';
};

export class BusinessInfo extends React.Component<BusinessInfoProps, State> {
  constructor(props: BusinessInfoProps) {
    super(props);
    const { fetchBusinessTypes, update, country } = this.props;
    if (country === 'US' && fetchBusinessTypes) {
      fetchBusinessTypes();
    }
    if (country !== 'US' && businessTypes.length > 0) {
      update({ typeOfBusiness: businessTypes[0].value });
    }
    update({ state: getDefaultState(country as Countries) });
  }

  public readonly state: State = {
    suggestions: [],
    usBusinessTypeValie: '',
    isAutocompleteOpen: false,
    listOfPds: [],
    listOfSelectedPds: [],
    selectedPdsItems: '',
    listOfPdsDropdown: [],
    defaultCategory: 'HBW',
    isSelected: '',
  };
  findItem = (x: string) => {
    let listOfPdsDropdownSearch = this.state.listOfPdsDropdown;

    for (let i = 0; i < listOfPdsDropdownSearch.length; i++) {
      for (let j = 0; j < this.state.listOfPdsDropdown[i].options.length; j++) {
        if (this.state.listOfPdsDropdown[i].options[j].value === x) {
          return this.state.listOfPdsDropdown[i].label;
        }
      }
    }
  };

  onChangeMultiSelect = (value: BusinessType[]): void => {
    let typeOfBusinessValue: string[] = [];
    let selectedPDSService: BusinessType[] = [];
    let getItemCat: string | undefined = '';
    if (value) {
      value.map(function(element) {
        selectedPDSService.push(element);
        typeOfBusinessValue.push(element.value);
      });
      if (value[0].value) {
        let getItemCat = this.findItem(value[0].value);
        if (getItemCat) {
          this.categorySelected(getItemCat);
          this.alterData(getItemCat);
        }
      }
    }
    this.setState({
      listOfSelectedPds: selectedPDSService,
    });
    const { update } = this.props;
    update({
      typeOfBusiness: typeOfBusinessValue,
    });
  };

  alterData = (catLabel: string) => {
    const { businessTypes, update } = this.props;
    let temporaryPdsList: ListOfPds[] = [];
    businessTypes.forEach(function(element, index) {
      if (element.label.toLowerCase() === catLabel.toLowerCase()) {
        temporaryPdsList.push(element);
        businessTypes.splice(index, 1);
      }
    });
    if (temporaryPdsList.length) {
      businessTypes.unshift(...temporaryPdsList);
    }
    catLabel = catLabel.replace(/\s\/\s/g, '/');
    this.categorySelected(catLabel);
    update({
      categoryPds: catLabel,
    });
  };

  isSelected = (elementid: string) => {
    elementid = elementid.replace(/\s\/\s/g, '/');
    return this.state.isSelected === elementid;
  };

  categorySelected = (isSelected: string) => {
    this.setState({ isSelected });
  };

  onInputChange = (value: string) => {
    if (value.length < 3) {
      this.setState({ listOfPds: [] });
      return;
    }
    let allPds = this.props.businessTypes;
    let filterDataList: ListOfPds[] = [];
    let optionArray: BusinessType[] = [];

    for (let j = 0; j < allPds.length; j++) {
      for (let i = 0; i < allPds[j].options.length; i++) {
        if (allPds[j].options[i].label.toLowerCase().includes(value.toLowerCase())) {
          let optionObject: BusinessType = { label: '', value: '' };
          optionObject.label = allPds[j].options[i].label;
          optionObject.value = allPds[j].options[i].value;
          optionArray.push(optionObject);
        }
      }
      if (optionArray.length > 0) {
        let obj = { label: allPds[j].label, options: optionArray };
        filterDataList.push(obj);
      }
      optionArray = [];
    }
    this.setState({ listOfPds: filterDataList, listOfPdsDropdown: filterDataList });
  };

  renderZipCodeInput = (): JSX.Element => {
    const { zipCode, validations, update } = this.props;
    return (
      <Input
        id="zipCode"
        title={translate('zipCode')}
        value={zipCode}
        onChange={value => update({ zipCode: value })}
        showRequiredMark={true}
        hasError={!!validations.zipCode}
        errorMessage={validations.zipCode && translate(`_validations.${validations.zipCode}`)}
        maxlength={250}
      />
    );
  };

  renderCityInput = (): JSX.Element => {
    const { city, validations, update } = this.props;
    return (
      <Input
        id="city"
        title={translate('city')}
        value={city}
        onChange={value => update({ city: value })}
        showRequiredMark={true}
        hasError={!!validations.city}
        errorMessage={validations.city && translate(`_validations.${validations.city}`)}
        maxlength={250}
      />
    );
  };

  renderZipCodeAndCityRow = (): JSX.Element => {
    const { country } = this.props;
    if (country === 'IE') {
      return (
        <div className="row">
          <div className="md-column sm-column">{this.renderCityInput()}</div>
        </div>
      );
    }
    return (
      <div className="row">
        <div className="md-column--3of5">{this.renderCityInput()}</div>
        <div className="md-column--2of5">{this.renderZipCodeInput()}</div>
      </div>
    );
  };

  onUSBusinessTypeSelected = (selectedItem: TagAutocompleteItem) => {
    const { update } = this.props;
    this.setState({ isAutocompleteOpen: false });
    update({ typeOfBusiness: selectedItem ? selectedItem.value : undefined });
  };

  onAutocompleteFocus = () => {
    this.setState({ isAutocompleteOpen: true });
  };

  onAutocompleteBlur = () => {
    this.setState({ isAutocompleteOpen: false });
  };

  onAutocompleteTagClick = () => {
    const { update } = this.props;
    update({ typeOfBusiness: '' });
    this.setState({ usBusinessTypeValie: '' });
  };

  renderUSBusinessTypeSelector = (): JSX.Element => {
    const { validations } = this.props;
    return (
      <div>
        <label htmlFor="" className={styles.labelForSelect}>
          {`${translate('pdsTitle')} *`}
        </label>
        <Multiselect
          id="typeOfBusiness"
          showRequiredMark={true}
          hasError={!!validations.typeOfBusiness}
          errorMessage={
            validations.typeOfBusiness && translate(`_validations.${validations.typeOfBusiness}`)
          }
          listOfSelectedPds={this.state.listOfSelectedPds}
          selectedPdsItems={this.state.selectedPdsItems}
          onChangeMultiSelect={this.onChangeMultiSelect}
          onInputChange={(value: string) => this.onInputChange(value)}
          listOfPds={this.state.listOfPds}
        />
      </div>
    );
  };

  renderCountries(): JSX.Element | null {
    const { country, update } = this.props;
    if (COUNTRIES_PICKER[I18n.country]) {
      return (
        <div className="md-column">
          <Select
            options={(COUNTRIES_PICKER[I18n.country] || []).map(
              (item: SelectorProps): SelectOption => {
                return { text: item.name, value: item.value };
              },
            )}
            id="country"
            title={translate('country')}
            value={country}
            onChange={value => {
              let typeOfBusiness = '';
              if (value === 'CA') {
                typeOfBusiness = businessTypes[0].value;
              }
              update({
                country: value,
                state: getDefaultState(value as Countries),
                typeOfBusiness,
              });
            }}
            showRequiredMark={true}
          />
        </div>
      );
    }
    return null;
  }

  renderStates(): JSX.Element | null {
    const { country, state, update } = this.props;
    if (STATES[country]) {
      return (
        <div className="md-column">
          <Select
            options={(STATES[country] || []).map(
              (item: SelectorProps): SelectOption => {
                return { text: item.value, value: item.name };
              },
            )}
            id="state"
            title={translate('state')}
            value={state}
            onChange={value => update({ state: value })}
            showRequiredMark={true}
          />
        </div>
      );
    }
    return null;
  }

  renderEMEABusinessTypeSelector = (): JSX.Element => {
    const { typeOfBusiness, update, validations } = this.props;
    return (
      <Select
        options={businessTypes.map(
          (item): SelectOption => {
            return { text: translate(`_businessTypes.${item.key}`), value: item.value };
          },
        )}
        id="typeOfBusiness"
        title={translate('typeOfBusiness')}
        value={typeOfBusiness}
        onChange={value => update({ typeOfBusiness: value })}
        showRequiredMark={true}
        hasError={!!validations.typeOfBusiness}
        errorMessage={
          validations.typeOfBusiness && translate(`_validations.${validations.typeOfBusiness}`)
        }
      />
    );
  };

  renderBusinessTypeSelector = (): JSX.Element => {
    if (this.props.country === 'US') {
      return this.renderUSBusinessTypeSelector();
    }
    return this.renderEMEABusinessTypeSelector();
  };

  renderSubmitButton = (): JSX.Element => {
    const { isLoading, onSubmit, country } = this.props;
    if (isLoading) {
      return (
        <div className={classNames(styles.loaderContainer)}>
          <Spinner size={64} />
        </div>
      );
    }

    return (
      <button
        data-bhc="signup-submit"
        className="button-primary button-cta submit btn btn-buy next"
        disabled={isLoading}
        onClick={e => {
          e.preventDefault();
          onSubmit(this.props, country);
        }}
      >
        {translate('submit')}
      </button>
    );
  };

  getIconComponent(dynamicIconComponent: string) {
    switch (dynamicIconComponent) {
      case 'IconCategoryHBW':
        return <IconCategoryHBW width={36} />;
      case 'IconCategoryAE':
        return <IconCategoryAE width={36} />;
      case 'IconCategoryGR':
        return <IconCategoryGR width={36} />;
      case 'IconCategoryFD':
        return <IconCategoryFD width={36} />;
      case 'IconCategoryHA':
        return <IconCategoryHA width={36} />;
      default:
        return ' ';
    }
  }

  render() {
    const {
      isLoading,
      update,
      businessName,
      streetAddress,
      website,
      physicalLocations,
      fullName,
      phone,
      email,
      grouponSubscription,
      validations,
      onSubmit,
      isSubmitted,
      hasError,
      freshRegistration,
      id,
      sf_id,
      dashboard,
      businessTypes,
      country,
    } = this.props;
    if (isSubmitted && !hasError) {
      if (dashboard === 'rep' || Boolean(sf_id)) {
        return <Redirect to="/success/inbound" />;
      }
      if (freshRegistration === false) {
        return <Redirect to="/success/user-return" />;
      } else {
        return <Redirect to="/success/user-signup" />;
      }
    }
    const buttonsCategories = [];
    for (let i = 0; i < categories.length; i++) {
      let category = categories[i];
      let dynamicIconComponent = iconCategories[i];

      buttonsCategories.push(
        <button
          data-bhc="signup-submit"
          className={`button-secondary button ${styles.buttonSquare}
          ${this.isSelected(translate(category)) ? styles.buttonSelected : ''} `}
          onClick={e => {
            e.preventDefault();
            this.alterData(translate(category));
          }}
        >
          {this.getIconComponent(dynamicIconComponent)}
          <span className={styles.categoryText}>{translate(category)}</span>
        </button>,
      );
    }

    const isWebsiteMandatory = I18n.country === 'US';

    return (
      <form data-bhw="w2lForm" className="mx-main">
        <div className="mx-main-content">
          <div className="row">
            <div className="md-column">
              <h1>{translate('title')}</h1>
            </div>
          </div>
          <div className="row">
            <div className="md-column">
              <p>{translate('description')}</p>
            </div>
          </div>
          <div className="row">
            <div className="md-column">
              <p>{translate('reuiredMarkDescription')}</p>
            </div>
          </div>
          <div className="row">
            <div className="md-column">
              <h3>{translate('businessDescription')}</h3>
            </div>
          </div>
          <div className="row">
            <div className="md-column">
              <Input
                id="businessName"
                title={translate('businessName')}
                onChange={value => update({ businessName: value })}
                value={businessName}
                showRequiredMark={true}
                hasError={!!validations.businessName}
                errorMessage={
                  validations.businessName && translate(`_validations.${validations.businessName}`)
                }
                maxlength={250}
              />
            </div>
          </div>
          <div className="row">
            <div className="md-column">
              <Input
                id="streetAddress"
                title={translate('streetAddress')}
                value={streetAddress}
                onChange={value => update({ streetAddress: value })}
                showRequiredMark={true}
                hasError={!!validations.streetAddress}
                errorMessage={
                  validations.streetAddress &&
                  translate(`_validations.${validations.streetAddress}`)
                }
                maxlength={250}
              />
            </div>
          </div>
          {this.renderZipCodeAndCityRow()}
          <div className="row">
            {this.renderStates()}
            {this.renderCountries()}
          </div>
          <div className="row">
            <div className="md-column">
              <Input
                id="website"
                title={translate('website')}
                value={website}
                onChange={value => update({ website: value })}
                showRequiredMark={isWebsiteMandatory}
                hasError={!!validations.website}
                errorMessage={
                  validations.website && translate(`_validations.${validations.website}`)
                }
                maxlength={250}
              />
            </div>
          </div>
          <div className="row">
            <div className="md-column">
              <h3
                className={classNames(Boolean(validations.physicalLocations) ? styles.error : '')}
                {...testId(
                  validations.physicalLocations ? 'physical-locations-header-with-error' : '',
                )}
              >{`${translate('locationTitle')} *`}</h3>
            </div>
          </div>
          <div className="row">
            <div className="md-column">
              <div>
                <RadioButton
                  id="one"
                  onChange={() => update({ physicalLocations: '1' })}
                  value={'1'}
                  checked={physicalLocations === '1'}
                >
                  {translate('_numberOfLocations.one')}
                </RadioButton>
              </div>
              <div>
                <RadioButton
                  id="multiple"
                  onChange={() => update({ physicalLocations: '2' })}
                  value={'2'}
                  checked={physicalLocations === '2'}
                >
                  {translate('_numberOfLocations.multiple')}
                </RadioButton>
              </div>
              <div>
                <RadioButton
                  id="none"
                  onChange={() => update({ physicalLocations: '0' })}
                  value={'0'}
                  checked={physicalLocations === '0'}
                >
                  {translate('_numberOfLocations.none')}
                </RadioButton>
              </div>
            </div>
          </div>
          {country === 'US' && (
            <div className="row">
              <div className="md-column">
                <h3>{`${translate('categoryTitle')} *`}</h3>
              </div>
            </div>
          )}
          <div className="row">
            <div
              ref="category"
              className={classNames({
                'md-column': true,
                [`${styles.buttonGroup}`]: country === 'US',
                [`${styles.buttonGroup} ${styles.hide}`]: country !== 'US',
              })}
            >
              {buttonsCategories}

              {!!validations.categoryPds ? (
                <span className="category-error mx-error-message">
                  {validations.categoryPds && translate(`_validations.${validations.categoryPds}`)}
                </span>
              ) : null}
            </div>
          </div>
          <div className="row">
            <div className="md-column">{this.renderBusinessTypeSelector()}</div>
          </div>
          <div className="row">
            <div className="md-column">
              <h3>{translate('contactsBlockHeader')}</h3>
            </div>
          </div>
          <div className="row">
            <div className="md-column">
              <Input
                id="fullName"
                title={translate('fullName')}
                value={fullName}
                onChange={value => update({ fullName: value })}
                showRequiredMark={true}
                hasError={!!validations.fullName}
                errorMessage={
                  validations.fullName && translate(`_validations.fullName.${validations.fullName}`)
                }
                maxlength={250}
              />
            </div>
          </div>
          <div className="row">
            <div className="md-column">
              <Input
                id="phone"
                title={translate('phone')}
                value={phone}
                onChange={value => update({ phone: value })}
                showRequiredMark={true}
                hasError={!!validations.phone}
                errorMessage={validations.phone && translate(`_validations.${validations.phone}`)}
                maxlength={250}
              />
            </div>
          </div>
          <div className="row">
            <div className="md-column">
              <Input
                id="email"
                title={translate('email')}
                value={email}
                onChange={value => update({ email: value })}
                showRequiredMark={true}
                hasError={!!validations.email}
                errorMessage={validations.email && translate(`_validations.${validations.email}`)}
                maxlength={250}
              />
            </div>
          </div>
          <div className="row">
            <div className="md-column sm-column">
              <div className="checkbox-group">
                <label className="checkbox-label" htmlFor="grouponSubscription">
                  <input
                    checked={!grouponSubscription}
                    type="checkbox"
                    id="grouponSubscription"
                    onChange={() => {
                      update({ grouponSubscription: !grouponSubscription });
                    }}
                  />
                  <span className="checkbox" />
                  {translate('grouponSubscription')}
                </label>
              </div>
            </div>
          </div>
          <div className={classNames('row', styles.termsOfUseContainer)}>
            <div
              className="md-column sm-column"
              dangerouslySetInnerHTML={{
                __html: `${translate('consentMessage', consentMessageParams)} `,
              }}
            />
          </div>
          <div className="row">
            <div className="md-column">{this.renderSubmitButton()}</div>
          </div>
        </div>
      </form>
    );
  }
}

export default BusinessInfo;
